import { createFileRoute, redirect } from '@tanstack/react-router'
import { CustomerEditView } from '@/features/customers/customers'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/customers/$customerId/edit')({
  beforeLoad: ({ context, params }) => {
    if (!hasGrant(context.queryClient, 'customer.edit')) {
      throw redirect({
        to: '/customers/$customerId',
        params: { customerId: params.customerId },
      })
    }
  },
  component: CustomerEditView,
})
